// 📨 The admin's answers to her (price requests and comments) — at the TOP of her list until she taps "شفت" (2026-11-05:
// "my reply doesn't reach her"). Backend: buyerReplies / markReplySeen in controllers/shopping-list.js
import { FC, useCallback, useEffect, useState } from 'react';
import type { AxiosInstance } from 'axios';

interface Reply { id: string; kind: string; status: 'approved' | 'refused' | 'answered'; note: string | null; price: number | null; adminNote: string | null; approvedQty: number | null; approvedPrice: number | null; at: string; name: string; image: string | null }

const AdminReplies: FC<{ api: AxiosInstance }> = ({ api }) => {
  const [rows, setRows] = useState<Reply[]>([]);
  const load = useCallback(async () => { try { setRows((await api.get('/shopping-list/replies')).data || []); } catch { /* the list still works */ } }, [api]);
  useEffect(() => { load(); }, [load]);
  if (!rows.length) return null;
  const seen = async (id: string) => { await api.post(`/shopping-list/replies/${id}/seen`).catch(() => {}); setRows((r) => r.filter((x) => x.id !== id)); };
  const head = (r: Reply) => r.kind === 'comment'
    ? (r.status === 'approved' ? '✅ وافق على ملاحظتك' : r.status === 'refused' ? '❌ ما وافقش على ملاحظتك' : '💬 جاوب على ملاحظتك')
    : (r.status === 'approved' ? `✅ وافق: شري ${r.approvedQty ?? ''} قطعة بـ ${r.approvedPrice ?? r.price} درهم أو أقل` : `❌ ما تشريش بـ ${r.price} درهم`);
  return (
    <div style={{ marginBottom: 12, background: '#eff6ff', border: '2px solid #93c5fd', borderRadius: 14, padding: 10 }}>
      <div style={{ fontWeight: 900, fontSize: 16, color: '#1d4ed8', marginBottom: 6 }}>📨 جواب المسؤول ({rows.length})</div>
      {rows.map((r) => (
        <div key={r.id} style={{ background: '#fff', borderRadius: 12, padding: 8, marginBottom: 6, display: 'flex', gap: 10, alignItems: 'center' }}>
          {r.image ? <img src={r.image} alt="" style={{ width: 48, height: 48, objectFit: 'contain', borderRadius: 8 }} /> : null}
          <div style={{ flex: 1, minWidth: 0, fontSize: 14 }}>
            <div style={{ fontWeight: 800 }}>{r.name}</div>
            <div style={{ fontWeight: 700, color: r.status === 'refused' ? '#b91c1c' : r.status === 'answered' ? '#0f766e' : '#047857' }}>{head(r)}</div>
            {r.note && <div style={{ color: '#64748b', fontSize: 13 }}>كتبتي: «{r.note}»</div>}
            {r.adminNote && <div style={{ marginTop: 2, background: '#f8fafc', borderRadius: 8, padding: '4px 8px' }}>🗣️ {r.adminNote}</div>}
          </div>
          <button onClick={() => seen(r.id)} style={{ minHeight: 40, borderRadius: 10, border: 'none', background: '#1d4ed8', color: '#fff', fontWeight: 800, padding: '0 12px' }}>شفت ✓</button>
        </div>
      ))}
    </div>
  );
};
export default AdminReplies;
